import BarButtonFw, {BUTTON_DEFAULT} from '../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT } from '../../../framework/grid/GridFw'
import { BasePage } from "../../../framework/pages/BasePage";  
import { DateUtil } from '../../../util/DateUtil';
import { DATE_FORMAT,MIME_TYPE } from '../../../constants/constants';
import { DocumentPreview } from '../../viewDocument/DocumentPreview'; 
import { LoadingUtil } from '../../../util/LoadingUtil';
import { EnvConstants } from '../../../EnvConstants';
import { DonwloadUtil } from '../../../util/DonwloadUtil';
import { ReportUtil } from '../../../util/ReportUtil';
import { UserUtil } from '../../../util/UserUtil';
import confirm from 'antd/lib/modal/confirm';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { LoadUtil } from '../../../framework/util/LoadUtil';
import { MessageUtil } from '../../../util/MessageUtil';

export class ServiciosEjecutadosAdminPage extends BasePage {

    createPageProperties = (pageApi) => {
    return {
        title: 'SOLICITUDES DE SERVICIO'
        };
    }

    componentDidMount() {
        sessionStorage.removeItem("datos_emision_informe_factura");
    }
 
    renderPage(pageApi) {
        const getGrid = () => pageApi.getComponent('grid');
        const getForm = () => pageApi.getComponent('form');
 
        const DocumentPreviewModal = (data) => {
            return {
                width: 950,
                maskClosable: true,
                closable: false,
                component: <DocumentPreview name={data} getParentApi={pageApi.getApi} />
            }
        }; 

        const RetornaVisulizacionBoton = (estado, opcion) => {
            let opciones = {
                pendiente: ['editar', 'anular', 'configurar', 'descargar_solicitud_ejecutada', 'visualizar_solicitud_ejecutada'],
                aprobado: ['anular', 'configurar', 'descargar_solicitud_aprobada', 'visualizar_solicitud_aprobada'],
                anulado: ['configurar', 'crear_version', 'descargar_solicitud_ejecutada', 'visualizar_solicitud_ejecutada'],
            }
            
            let arrValidacion = [
                {
                    estado: 'Pendiente',
                    opciones: opciones.pendiente
                },
                {
                    estado: 'Aprobado',
                    opciones: opciones.aprobado
                },
                {
                    estado: 'Anulado',
                    opciones: opciones.anulado
                },
            ]

            const objCoti = arrValidacion.find(el => el.estado === estado) || {};
            let viewBoton = objCoti?.opciones?.includes(opcion);
            return viewBoton || false;
        }

        const formConfig = {
            layout: 'vertical',
            values: {
                estadoSS: 0,
            },
            fields:[               
                {name: 'nro_coti', label:'Nro. Cotización :', column: 2},    
                {name: 'nro_ss', label:'Nro. Servicio :', column: 2},  
                {type: 'select', name:'estadoSS', label:'Estado', column: 2,
                    load: {
                        dataList: [
                            {label: 'Todos', value: 0},
                            {label: 'Pendiente', value: 1},
                            {label: 'Aprobado', value: 2},
                            {label: 'Anulado', value: 3}
                        ]
                    }, 
                }, 
                {type: 'date', name:'fecha_desde', label:'Desde', column: 2, value: DateUtil.getDate2(15), format: DATE_FORMAT.DDMMYYYY, inputFormat: DATE_FORMAT.YYYYMMDD},  
                {type: 'date', name:'fecha_hasta', label:'Hasta', column: 2, value: DateUtil.getDate, format: DATE_FORMAT.DDMMYYYY, inputFormat: DATE_FORMAT.YYYYMMDD},
            ]
        };
 
        const gridConfig = {
            showIndex: true,
            autoLoad: true,
            pagination: {server: true},
            load: { 
                queryId: 812, 
                params: {
                    id_user: UserUtil.getUserId()
                },
                hideMessage: true,
                hideMessageError: true,
            },
            fields:[
                {name:'tipo_servicio', label:'Tipo Servicio'},
                {name:'doc_nro_ss', label:'Nro Solicitud'},
                {name:'doc_nro_cotizacion', label:'Nro Cotizacion'},
                {name:'raz_soc', label:'Empresa'},
                {name:'referencia_proyecto', label:'Referencias'},
                {name:'SOLICITANTE', label:'Solicitante'},
                {name:'fecha_emision', label:'Fecha Emision'}, 
                {name:'estado', label:'Estado'},
                {...COLUMN_DEFAULT.EDIT, label: 'Opciones', colSpan: 6, title: 'Configurar Solicitud', color: 'blue', 
                    link: (value, row, index) => {
                        sessionStorage.setItem("ruta_retorno_ejecutar_servicio", "/servicios-ejecutados/servicios-ejecutados-admin");
                        return `/servicios-ejecutados/servicios-ejecutados/${row.estado_tab}/${row.id_doc}`
                    },
                    fnVisible: (value, row, index) => {
                        return RetornaVisulizacionBoton(row?.estado, 'editar')
                    }, 
                }, 
                {...COLUMN_DEFAULT.CANCEL, colSpan:0, title: 'Anular Solicitud', color: 'red',
                    onClick: (value, row) => { 
                        confirm({
                            title: '¿Desea anular la Solicitud?',
                            icon: <ExclamationCircleOutlined />,
                            content: 'N° de Solicitud:  ' + row.doc_nro_ss,
                            onOk() {
                                LoadUtil.loadByQueryId({
                                    url: EnvConstants.GET_FW_FORM_URL_UPDATE_BASE(),
                                    queryId: 252,
                                    reqParams: {
                                        params: {id_doc: row.id_doc, id_user: UserUtil.getUserId()},
                                    },
                                    fnOk: (resp) => {
                                        getGrid().load({params:getForm().getData()});
                                        MessageUtil("success", "Se ha eliminado correctamente.", "");
                                    },
                                });
                            }
                        })
                    },
                    fnVisible: (value, row, index) => {
                        return RetornaVisulizacionBoton(row?.estado, 'anular')
                    }, 
                },
                {...COLUMN_DEFAULT.DOWNLOAD, title: 'Descargar Solicitud Aprobada', color: '#820014', colSpan:0, onClick: (value, row, index)=> 
                    {
                        LoadingUtil.loadShow();

                        let url = EnvConstants.GET_REPORT2_URL() + 'SolicitudMa_aprobada';     
                        ReportUtil.donwloadFromPost(url, {params: {id_doc: row.id_doc}}, "Solicitud_Servicio_"+row.doc_nro_ss+".pdf").then(x => {
                            LoadingUtil.loadHide();
                        }).catch(x => {
                            console.error(x)
                            LoadingUtil.loadHide();
                        }); 
                    },
                    fnVisible: (value, row, index) => {
                        return RetornaVisulizacionBoton(row?.estado, 'descargar_solicitud_aprobada')
                    }, 
                },
                {...COLUMN_DEFAULT.PDF, title:'Visualizar Solicitud Aprobada', color:'black', colSpan: 0, onClick: (value, row, index)=> 
                    {
                    LoadingUtil.loadShow(); 
                    let url = EnvConstants.GET_REPORT2_URL() + 'SolicitudMa_aprobada';
                    DonwloadUtil.donwloadBlob(url, {params: {id_doc: row.id_doc}}, "Solicitud_Servicio_"+row.doc_nro_ss+".pdf").then(x => {
                        
                        var reader = new FileReader();
                        reader.readAsDataURL(x.blob); 
                        reader.onloadend = function() {
                            var base64data = reader.result;    
                            let obj = {
                                url: base64data,
                                type_file: MIME_TYPE.pdf
                            }
                            pageApi.showModal(DocumentPreviewModal(obj));
                            LoadingUtil.loadHide();
                        }
                    }).catch(x => {
                        console.error(x)
                        LoadingUtil.loadHide();
                    });
                    },
                    fnVisible: (value, row, index) => {
                        return RetornaVisulizacionBoton(row?.estado, 'visualizar_solicitud_aprobada')
                    }, 
                },
            ]
        };
    
        const barButtonconfig = {
            fields:[
                {...BUTTON_DEFAULT.SEARCH, onClick: ()=>getGrid().load({params:getForm().getData()})},
                {...BUTTON_DEFAULT.CLEAR1, onClick: () => getForm().setData({
                    nro_coti: '',
                    nro_ss: '',
                    estadoSS: 0,
                    fecha_desde: DateUtil.getDate2(15),
                    fecha_hasta: DateUtil.getDate
                })},
            ]
        }
    
        return (
            <>
                <FormFw
                    name="form"
                    getParentApi={pageApi.getApi}
                    config={formConfig}
                />
                <BarButtonFw  
                    name="bar"
                    getParentApi={pageApi.getApi}
                    config={barButtonconfig}
                />
                <GridFw 
                    name="grid"
                    getParentApi={pageApi.getApi}
                    config={gridConfig} 
                />
            </>
        )
    }
}
